import { Dayjs } from 'dayjs'

export type QuickRangeKey =
  | 'today' | 'yesterday'
  | 'this_week' | 'past_week'
  | 'last_7' | 'last_30' | 'last_90'
  | 'this_month' | 'past_month'
  | 'this_year' | 'past_year'
  | 'custom'

type RangeGetter = (now: Dayjs) => { start: Dayjs; end: Dayjs }

function startOfWeekMonday(d: Dayjs) {
  const dow = d.day()
  const offset = (dow + 6) % 7
  return d.subtract(offset, 'day').startOf('day')
}
function endOfWeekSunday(d: Dayjs) {
  const start = startOfWeekMonday(d)
  return start.add(6, 'day').endOf('day')
}

export const RANGE_DEFS: Record<QuickRangeKey, RangeGetter> = {
  today: now => ({ start: now.startOf('day'), end: now.endOf('day') }),
  yesterday: now => {
    const y = now.subtract(1, 'day')
    return { start: y.startOf('day'), end: y.endOf('day') }
  },
  this_week: now => ({ start: startOfWeekMonday(now), end: endOfWeekSunday(now) }),
  past_week: now => {
    const start = startOfWeekMonday(now).subtract(7, 'day')
    return { start, end: start.add(6, 'day').endOf('day') }
  },
  last_7:  now => ({ start: now.subtract(6,  'day').startOf('day'), end: now.endOf('day') }),
  last_30: now => ({ start: now.subtract(29, 'day').startOf('day'), end: now.endOf('day') }),
  last_90: now => ({ start: now.subtract(89, 'day').startOf('day'), end: now.endOf('day') }),
  this_month: now => ({ start: now.startOf('month'), end: now.endOf('month') }),
  past_month: now => {
    const m = now.subtract(1, 'month')
    return { start: m.startOf('month'), end: m.endOf('month') }
  },
  this_year: now => ({ start: now.startOf('year'), end: now.endOf('year') }),
  past_year: now => {
    const y = now.subtract(1, 'year')
    return { start: y.startOf('year'), end: y.endOf('year') }
  },
  custom: now => ({ start: now.startOf('day'), end: now.endOf('day') })
}
